import { createFileRoute } from "@tanstack/react-router";

import { ShippingScreen } from "../../-components/Withdrawal/ShippingScreen";

export const Route = createFileRoute("/_authenticated/trade/withdraw/products/shipping")({ component: ShippingScreen });
